export default "__VITE_ASSET__aKs2zrLx__"